export enum IDV_MODE_ENUM {
    NONE = 'NONE',
    EXTERNAL = 'EXTERNAL',
    INTERNAL = 'INTERNAL'
}
